import * as Dialog from '@radix-ui/react-dialog'

export * from './Body'
export * from './Content'
export * from './Close'
export * from './Description'
export * from './Footer'
export * from './Title'
export * from './MultiStep'
export {
  classes as selectors,
  cssVariables,
  Overlay as modalOverlayStyles,
} from './styles'

/**
 * Modal component based on the Radix UI primitive Dialog component.
 * For more info see the Radix UI documentation: https://www.radix-ui.com/docs/primitives/components/dialog
 */

export type RootProps = Dialog.DialogProps
export const Root = Dialog.Root
export const Trigger = Dialog.Trigger
